import { FormElementThemeColor, StyledFormElements, formElementThemes } from '@tmh-website/ui/FormElements';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

export const Entry = styled.div<{ $isDisabled: boolean; $themeColor: FormElementThemeColor }>`
  display: flex;
  gap: ${props => props.theme.gap.xSmall};
  align-items: center;
  justify-content: space-between;
  margin-right: -8px;
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};

  ${props =>
    props.$isDisabled &&
    css`
      color: ${transparentize(0.6, props.theme.color[formElementThemes[props.$themeColor].text])};
    `};
`;

export const Checkmark = styled.div<{ $isVisible?: boolean; $isDisabled: boolean; $themeColor: FormElementThemeColor }>`
  width: 30px;
  height: 30px;
  margin: -8px 0;
  background-image: ${props =>
    `url("data:image/svg+xml,${encodeURIComponent(
      StyledFormElements.checkmarkSvg.replace('%FILL%', props.theme.color[formElementThemes[props.$themeColor].text])
    )}")`};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 75% auto;
  opacity: 0;
  transition: all 0.2s ease 0.15s;
  transform: rotate(45deg);

  ${props =>
    props.$isVisible &&
    css`
      opacity: 1;
      transform: rotate(0);
    `};

  ${props =>
    props.$isDisabled &&
    css`
      background-image: ${`url("data:image/svg+xml,${encodeURIComponent(
        StyledFormElements.checkmarkSvg.replace(
          '%FILL%',
          transparentize(0.6, props.theme.color[formElementThemes[props.$themeColor].text])
        )
      )}")`};
    `};
`;
